import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/search',
    component: ComponentCreator('/search', '822'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '1b6'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', '4a7'),
        routes: [
          {
            path: '/docs',
            component: ComponentCreator('/docs', '19c'),
            routes: [
              {
                path: '/docs/api-reference/overview',
                component: ComponentCreator('/docs/api-reference/overview', 'e31'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/add-customer-address',
                component: ComponentCreator('/docs/api-reference/public/add-customer-address', 'cab'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/advance-sandbox-subscription-billing',
                component: ComponentCreator('/docs/api-reference/public/advance-sandbox-subscription-billing', 'e20'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/apply-checkout-session-coupon',
                component: ComponentCreator('/docs/api-reference/public/apply-checkout-session-coupon', 'baf'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/archive-plan',
                component: ComponentCreator('/docs/api-reference/public/archive-plan', '3c7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/archive-product',
                component: ComponentCreator('/docs/api-reference/public/archive-product', '062'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/cancel-charge',
                component: ComponentCreator('/docs/api-reference/public/cancel-charge', '8ec'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/cancel-subscription',
                component: ComponentCreator('/docs/api-reference/public/cancel-subscription', 'fe7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/change-subscription-plan',
                component: ComponentCreator('/docs/api-reference/public/change-subscription-plan', '202'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-charge',
                component: ComponentCreator('/docs/api-reference/public/create-charge', '7b9'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-checkout-session',
                component: ComponentCreator('/docs/api-reference/public/create-checkout-session', '066'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-coupon',
                component: ComponentCreator('/docs/api-reference/public/create-coupon', '85f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-customer',
                component: ComponentCreator('/docs/api-reference/public/create-customer', '6d4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-plan',
                component: ComponentCreator('/docs/api-reference/public/create-plan', 'e5e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-product',
                component: ComponentCreator('/docs/api-reference/public/create-product', '706'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-product-digital-file-upload-url',
                component: ComponentCreator('/docs/api-reference/public/create-product-digital-file-upload-url', '2c4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-product-image-upload-url',
                component: ComponentCreator('/docs/api-reference/public/create-product-image-upload-url', '59a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/create-subscription',
                component: ComponentCreator('/docs/api-reference/public/create-subscription', '8e3'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/decide-sandbox-merchant-kyb',
                component: ComponentCreator('/docs/api-reference/public/decide-sandbox-merchant-kyb', 'c03'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/delete-customer-card',
                component: ComponentCreator('/docs/api-reference/public/delete-customer-card', '367'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/deliver-merchant-event',
                component: ComponentCreator('/docs/api-reference/public/deliver-merchant-event', 'b36'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/disable-coupon',
                component: ComponentCreator('/docs/api-reference/public/disable-coupon', 'e6c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-checkout-session-public-view',
                component: ComponentCreator('/docs/api-reference/public/get-checkout-session-public-view', '492'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-checkout-session-status',
                component: ComponentCreator('/docs/api-reference/public/get-checkout-session-status', '5d0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-coupon',
                component: ComponentCreator('/docs/api-reference/public/get-coupon', '163'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-customer',
                component: ComponentCreator('/docs/api-reference/public/get-customer', '25a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-plan',
                component: ComponentCreator('/docs/api-reference/public/get-plan', '59b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-product',
                component: ComponentCreator('/docs/api-reference/public/get-product', 'a9c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-refund',
                component: ComponentCreator('/docs/api-reference/public/get-refund', '2b0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/get-subscription',
                component: ComponentCreator('/docs/api-reference/public/get-subscription', '84b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-charge-refunds',
                component: ComponentCreator('/docs/api-reference/public/list-charge-refunds', '980'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-charges',
                component: ComponentCreator('/docs/api-reference/public/list-charges', '9d8'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-coupons',
                component: ComponentCreator('/docs/api-reference/public/list-coupons', '974'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-customer-cards',
                component: ComponentCreator('/docs/api-reference/public/list-customer-cards', '779'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-customers',
                component: ComponentCreator('/docs/api-reference/public/list-customers', '87d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-plans',
                component: ComponentCreator('/docs/api-reference/public/list-plans', '475'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-products',
                component: ComponentCreator('/docs/api-reference/public/list-products', '972'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/list-subscriptions',
                component: ComponentCreator('/docs/api-reference/public/list-subscriptions', 'eb1'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/mupag-public-merchant-api',
                component: ComponentCreator('/docs/api-reference/public/mupag-public-merchant-api', '056'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/patch-subscription',
                component: ComponentCreator('/docs/api-reference/public/patch-subscription', 'b14'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/pause-subscription',
                component: ComponentCreator('/docs/api-reference/public/pause-subscription', '48f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/pay-checkout-session',
                component: ComponentCreator('/docs/api-reference/public/pay-checkout-session', '56e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/reactivate-subscription',
                component: ComponentCreator('/docs/api-reference/public/reactivate-subscription', '23f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/remove-checkout-session-coupon',
                component: ComponentCreator('/docs/api-reference/public/remove-checkout-session-coupon', 'c47'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/renew-checkout-session',
                component: ComponentCreator('/docs/api-reference/public/renew-checkout-session', 'fed'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/request-refund',
                component: ComponentCreator('/docs/api-reference/public/request-refund', '12b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/resume-subscription',
                component: ComponentCreator('/docs/api-reference/public/resume-subscription', '5c6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/seed-sandbox-data',
                component: ComponentCreator('/docs/api-reference/public/seed-sandbox-data', '5b3'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/select-checkout-session-method',
                component: ComponentCreator('/docs/api-reference/public/select-checkout-session-method', '536'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/simulate-sandbox-charge-failed',
                component: ComponentCreator('/docs/api-reference/public/simulate-sandbox-charge-failed', '2ec'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/simulate-sandbox-charge-paid',
                component: ComponentCreator('/docs/api-reference/public/simulate-sandbox-charge-paid', '09d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/simulate-sandbox-psp-subaccount-decision',
                component: ComponentCreator('/docs/api-reference/public/simulate-sandbox-psp-subaccount-decision', '3da'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-coupon',
                component: ComponentCreator('/docs/api-reference/public/update-coupon', 'fd6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-customer',
                component: ComponentCreator('/docs/api-reference/public/update-customer', '4b4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-customer-address',
                component: ComponentCreator('/docs/api-reference/public/update-customer-address', 'ce2'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-plan',
                component: ComponentCreator('/docs/api-reference/public/update-plan', '9b7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-product',
                component: ComponentCreator('/docs/api-reference/public/update-product', '60a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/update-subscription-card',
                component: ComponentCreator('/docs/api-reference/public/update-subscription-card', '3bd'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-reference/public/validate-coupon',
                component: ComponentCreator('/docs/api-reference/public/validate-coupon', '3fd'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/changelog',
                component: ComponentCreator('/docs/changelog', '8fe'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/customers',
                component: ComponentCreator('/docs/customers', '562'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/customers/coupons',
                component: ComponentCreator('/docs/customers/coupons', '9c7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/customers/plans',
                component: ComponentCreator('/docs/customers/plans', 'a33'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/customers/products',
                component: ComponentCreator('/docs/customers/products', '2d5'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/finance/affiliates-and-payouts',
                component: ComponentCreator('/docs/finance/affiliates-and-payouts', '0a6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/fundamentals/errors',
                component: ComponentCreator('/docs/fundamentals/errors', 'd52'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/fundamentals/idempotency',
                component: ComponentCreator('/docs/fundamentals/idempotency', '4cb'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/fundamentals/pagination',
                component: ComponentCreator('/docs/fundamentals/pagination', '8c5'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/fundamentals/rate-limits',
                component: ComponentCreator('/docs/fundamentals/rate-limits', '1c8'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/fundamentals/versioning',
                component: ComponentCreator('/docs/fundamentals/versioning', 'd3f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/operations/status-support-feedback',
                component: ComponentCreator('/docs/operations/status-support-feedback', 'd93'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/payments/cards',
                component: ComponentCreator('/docs/payments/cards', 'ff0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/payments/charges',
                component: ComponentCreator('/docs/payments/charges', 'a59'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/payments/checkout',
                component: ComponentCreator('/docs/payments/checkout', 'e28'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/payments/pix',
                component: ComponentCreator('/docs/payments/pix', 'dd2'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/start/authentication',
                component: ComponentCreator('/docs/start/authentication', 'c73'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/start/environments',
                component: ComponentCreator('/docs/start/environments', '5b0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/start/overview',
                component: ComponentCreator('/docs/start/overview', 'e96'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/start/quickstart',
                component: ComponentCreator('/docs/start/quickstart', '683'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/subscriptions/overview',
                component: ComponentCreator('/docs/subscriptions/overview', '4c4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/tools/ai-integration',
                component: ComponentCreator('/docs/tools/ai-integration', '158'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/tools/sdk-and-tools',
                component: ComponentCreator('/docs/tools/sdk-and-tools', '5e4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/webhooks/event-catalog',
                component: ComponentCreator('/docs/webhooks/event-catalog', 'b50'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/webhooks/overview',
                component: ComponentCreator('/docs/webhooks/overview', 'aea'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/webhooks/replay-safety',
                component: ComponentCreator('/docs/webhooks/replay-safety', 'e31'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/webhooks/retries',
                component: ComponentCreator('/docs/webhooks/retries', 'e4c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/webhooks/signature',
                component: ComponentCreator('/docs/webhooks/signature', 'd61'),
                exact: true,
                sidebar: "docsSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
